import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from '@learningblocks/storybook-components';
import {OpenIcon, CloseIcon} from './Icons';
import style from './style.module.scss';

export function TestTubeDropdown(props) {
  const onChange = (data) => props.onChange({...data, sampleId: props.id});

  const setDropdownDisable = () => props.showFeedback && props.isCorrect;

  const setFeedbackClassName = () => {
    if (props.showFeedback) {
      if (props.isCorrect) {
        return style.dropdownCorrect;
      } else {
        return style.dropdownIncorrect;
      }
    } else {
      return '';
    }
  };

  return (
    <Dropdown
      placeholder='--'
      className={setFeedbackClassName()}
      options={props.options}
      value={props.currentValue}
      onChange={onChange}
      iconClose={CloseIcon}
      iconOpen={OpenIcon}
      disabled={setDropdownDisable()}
    />
  );
}

TestTubeDropdown.propTypes = {
  /**
   * List of options
   */
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Funciton to invoke when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Boolean value specifying if feedback should be displayed
   */
  showFeedback: PropTypes.bool,
  /**
   * Currently Selected value
   */
  currentValue: PropTypes.number,
  /**
   * Boolean specifying if dropdown state is correct
   */
  isCorrect: PropTypes.bool,
  /**
   * Unique id for the sample
   */
  id: PropTypes.number,
};
